// Runtime base path for serving the SPA under a sub-path (e.g. /bi/) behind the
// reverse proxy, without a separate build. The Go server injects
// window.__base__ into index.html (default "/").

export function basePath(): string {
  const b = (window as unknown as { __base__?: string }).__base__;
  return typeof b === 'string' && b ? b : '/';
}

// Prefix a root-absolute app path (e.g. "/api/x") with the base, no double slash.
export function apiUrl(path: string): string {
  const b = basePath().replace(/\/$/, ''); // "/bi/" -> "/bi", "/" -> ""
  return b + path;
}

export function wsUrl(path: string): string {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${apiUrl(path)}`;
}

// Patch window.fetch so the ~40 hardcoded fetch('/api/...') calls resolve under
// the base path without editing each one. No-op at root. Handles string + URL
// inputs (the codebase never passes a Request).
export function installBasePath(): void {
  if (basePath() === '/') return;
  const orig = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === 'string' && input.startsWith('/api/')) {
      return orig(apiUrl(input), init);
    }
    if (input instanceof URL && input.pathname.startsWith('/api/')) {
      return orig(apiUrl(input.pathname + input.search), init);
    }
    return orig(input, init);
  };
}
